import { IFeatureToggle } from './FeatureToggle'

export interface IBBLBase {
  name: string
  shortName: string
  phone: string
  email: string
  companyNumber: string
  clientNr: number
  externalPartnerNr: string
  businessAddress: string
  brandingCode: string
}

export interface IBBL extends IBBLBase {
  settings: IBBLSettings
  applications: IBBLApplications[]
  featureToggles: IFeatureToggle[]
}

export interface IBBLUrls {
  myPage: string
  oldMyPage: string
  financeInfocenter: string
  digitalCourseForResidents: string
  membershipTransfer: string
  newHousingProjects: string
  digitalCourseForBoard: string
  digitalCourseLegalTalk: string
  bevarHms: string
  bevarVedlikehold: string
  vedlikeholdSystem: string
  hmsSystem: string
  plussplan: string
  bblEgneKurs: string
  bblEgneVeiledninger: string
  forsikringsAvtale: string
  advokatforsikring: string
  skadedyravtalen: string
  bygningssjekken: string
  vedlikeholdSkadevern: string
}

export interface IBBLCarbonAccounting {
  hasCarbonAccounting: boolean
  pricePerMonthForConsumptionBasedCarbonAccounting: string | null
  isConfigured: boolean
}

export interface IBBLSettings {
  bblUrl: string
  urls: IBBLUrls
  preemptionInformationUrl: string
  commonPreemptionInformationUrl: string
  emailForGeneralQuestions: string
  emailForPortalQuestions: string
  phoneNumberForGeneralQuestions: string
  phoneNumberForPortalQuestions: string
  becomeAMemberUrl: string
  customPrivacyStatementUrl: string
  afterLogoutRedirectUrl: string
  emailInvoiceReception: string
  invoiceAddressPost: boolean
  invoiceApprovalAllowChangeApprover: boolean
  businessAddressPost: boolean
  gtmId: string
  carbonAccounting: IBBLCarbonAccounting
  isShareBoardMeetingProtocolConfigured: boolean
  emailInsurance: string
  displayNames: IDisplayNames
  isLateAdopterOfNewPortalBudget: boolean
  reimbursementMaxAmount: number
  delayedPaymentDaysFromFinancingInstitution: number
  isVotingEnabledForBulletinBoard: boolean
  navigateToLandingPageWhenBblLogoClickedInPortal: boolean
  showBblContactPersonsInPortal: boolean
}

export interface IBBLApplications {
  name: PortalTypesEnum
}

export interface IDisplayNames {
  portalDisplayName: string
  portalDisplayNameShort: string
  myPageDisplayName: string
  myPageDisplayNameShort: string
}

export enum PortalTypesEnum {
  Forkjop = 'Forkjøp',
  Portal = 'Portalen',
  MinSide = 'Min side',
}
